export default __webpack_public_path__ + "static/media/copy.e1798d71.svg";